import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  aboutPageAdditionalMeta,
  aboutPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';
import HeaderBanner from '../../components/general/HeaderBanner';
import AltHeader from '../../components/general/AltHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function AboutPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Step into the world of ${CompanyName}, where Mistress Maria commands with elegance, authority, and unapologetic dominance. Based in Norfolk, she specialises in real-time and online Femdom experiences for obedient submissives who crave true control.`}
        keywords={`Mistress Maria, about Mistress Maria, Dominatrix Norfolk, Femdom UK, BDSM Mistress, submissive training, sissy training, online domination, real-time sessions, mature Domme, Norfolk Dominatrix`}
        additionalMeta={aboutPageAdditionalMeta}
        structuredData={aboutPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={`About ${CompanyName}`} />

            <section className='grid w-full'>
              <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 py-8 text-lg tracking-wider'>
                <p>
                  Welcome to my world — I am Mistress Maria of Norfolk, a
                  captivating blend of nurturing care and firm dominance. Based
                  in central Norfolk, I offer immersive femdom and roleplay
                  experiences tailored to your deepest desires. Whether you seek
                  gentle age regression, strict nanny scenarios, sissy training,
                  bondage, or discipline, I bring creativity, control, and
                  intensity.{' '}
                </p>
                <p>
                  Sessions are available in person or online via WhatsApp,
                  email, or text. Whether you're shy or bold, craving nurturing
                  or punishment, I welcome your surrender. My time is valuable,
                  my presence commanding — step into my world and experience
                  true, unfiltered dominance.
                </p>
              </div>
            </section>
          </header>
        </div>

        {/* Main page content */}
        <AboutPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default AboutPage;
